import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { BPTQuestion } from '@/models/bpt.model';
import { PropType } from 'vue';
import { useStore } from 'vuex';
import { ShiftCMSState } from '@/store';
import { BPTStoreActions, BPTStoreState } from '@/stores/bpt.store';
import SortItems from '@/components/common/SortItems.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BPTQuestionsSortingForm',
  props: {
  data: {
    type: Array as PropType<BPTQuestion[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore<ShiftCMSState & { bpt: BPTStoreState }>();

const save = (v: number[]) => {
  store.dispatch(BPTStoreActions.UpdateQuestionOrder, v);
};

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Sort Questions", -1)),
      _createVNode(_component_v_alert, { type: "info" }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Sort the items in the order of which the questions will be presented.")
        ])),
        _: 1
      }),
      _createVNode(SortItems, {
        items: [...props.data],
        onChange: save,
        order: 
        [...props.data].sort((a, b) => a.index - b.index).map((s) => s.id)
      
      }, null, 8, ["items", "order"])
    ]),
    _: 1
  }))
}
}

})